module.exports = __webpack_public_path__ + "static/3i-e125f1e2de9a2150a521f55c482b8151.woff";